import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = ({ onFilterClick }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    window.location.href = 'https://app.cliccami.net/#/home-servizi';
  };

  const handleHomeClick = () => {
    navigate('/home-servizi');
  };

  const handleMailClick = () => {
    window.location.href = 'mailto:cliccaminet@gmail.com';
  };

  return (
    <header className="w-full bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        {/* Logo - Left Side */}
        <button
          onClick={handleLogoClick}
          className="flex items-center h-full py-2 transition-opacity hover:opacity-80"
          aria-label="Vai alla home"
        >
          <img
            src="/assets/images/logo-1771244548080.png"
            alt="Cliccami Logo"
            className="h-full w-auto object-contain"
          />
        </button>

        {/* Icons - Right Side */}
        <div className="flex items-center gap-4">
          {/* Home Icon */}
          <button
            onClick={handleHomeClick}
            className="p-2 rounded-lg transition-colors hover:bg-gray-100"
            aria-label="Home"
          >
            <Icon name="Home" size={24} className="text-gray-700" />
          </button>

          {/* Mail Icon */}
          <button
            onClick={handleMailClick}
            className="p-2 rounded-lg transition-colors hover:bg-gray-100"
            aria-label="Contattaci via email"
          >
            <Icon name="Mail" size={24} className="text-gray-700" />
          </button>

          {/* Filter Icon - Only show if onFilterClick is provided */}
          {onFilterClick && (
            <button
              onClick={onFilterClick}
              className="p-2 rounded-lg transition-colors hover:bg-gray-100"
              aria-label="Apri filtri"
            >
              <Icon name="SlidersHorizontal" size={24} className="text-gray-700" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;